import { T14 } from "./ComparativeMonthlyDrugstoreChain/T14";
import { T13 } from "./ComparativeMonthlySales/T13";
import { T15 } from "./ProductSalesChannel/T15";
import { T06 } from "./ProductSalesGrowthPerformance/T06";
import { T16 } from "./ProductsSalesCustomerGroup/T16";

export const AgentComparativeSales = {
    "sections": [
      T13,
      T06,
      T15,
      T16
    ]
  }
  